export default {
  'Image-Box': 'Bild-Box',
  'HTML-Box': 'HTML-Box',
  'Video-Box': 'Video-Box',
  'PDF-Box': 'PDF-Box',
  'Form-Box': 'Formular-Box',
  'Background Color': 'Hintergrundfarbe wählen',
  'Background Color Front': 'Hintergrundfarbe wählen (vorne)',
  'Background Color Back': 'Hintergrundfarbe wählen (hinten)',
  'Set Background Colors': 'Hintergrundfarben festlegen',
  'Text Color': 'Textfarbe wählen',
  'Text Color Front': 'Textfarbe wählen (vorne)',
  'Text Color Back': 'Textfarbe wählen (hinten)',
  'Set Text Colors': 'Textfarben festlegen',
  'Image File': 'Bilddatei',
  'Image Files': 'Bilddateien',
  'Video File': 'Videodatei',
  'PDF File': 'PDF-Datei',
  File: 'Datei',
  Form: 'Formular',
  PDF: 'PDF',
  Image: 'Bild',
  Video: 'Video',
  Gallery: 'Galerie',
  HTML: 'HTML',
  Content: 'HTML-Inhalt',
  'Show controls': 'Steuerelemente anzeigen',
  Mute: 'Stummschalten',
  Autoplay: 'Autoplay',
  Fullscreen: 'Vollbild',
  Mode: 'Modus',
  Continue: 'Fortsetzen',
  Startover: 'Von Anfang',
  'Custom classes': 'Weitere CSS-Klassen',
  Margin: 'Abstand',
  Padding: 'Innenabstand',
  Button: 'Button',
  'With Icon': 'Mit Icon',
  'Items Top': 'oben',
  'Items Center': 'vertikal zentriert',
  'Items Bottom': 'unten',
  Border: 'Rand',
  colorMain: 'Main',
  colorMainDarker: 'Main-Darker',
  colorMainLighter: 'Main-Lighter',
  colorSecondary: 'Secondary',
  colorTertiary: 'Tertiary',
  colorQuaternary: 'Quaternary',
  Main: 'Primär',
  'Main-Darker': 'Primär (dunkler)',
  'Main-Lighter': 'Primär (heller)',
  Secondary: 'Sekundär',
  Tertiary: 'Tertiär',
  Quaternary: 'Quartär',
  Black: 'Schwarz',
  None: 'Transparent',
  White: 'Weiß',
  Format: 'Format',
  'Choose format': 'Format wählen',
  Position: 'Position',
  'Choose position': 'Position wählen',
  Centered: 'Mittig',
  Standard: 'Standard',
  Left: 'Links',
  Right: 'Rechts',
  Scaled: 'Skaliert',
  'Scaled-X': 'Skaliert nach Breite',
  'Scaled-Y': 'Skaliert nach Höhe',
  Original: 'Original',
  Portrait: 'Hochformat (9:16)',
  Landscape: 'Querformat (16:9)',
  Link: 'Link festlegen',
  Name: 'Name',
  Type: 'Typ',
  'Input Type': 'Input-Typ',
  Input: 'Input-Feld',
  Checkbox: 'Checkbox',
  Submit: 'Absenden',
  Label: 'Beschriftung',
  Text: 'Text',
  'Button Text': 'Button Text',
  Flip: 'Flip',
  Y: 'Y',
  X: 'X',
  Alignment: 'Inhalt ausrichten',
  'Alignment front': 'Inhalt ausrichten (vorne)',
  'Alignment back': 'Inhalt ausrichten (hinten)',
  'Create form': 'Formular erstellen',
  'Expand Pages': 'Alle Seiten anzeigen',
  'Rename slide': 'Seite umbenennen',
  'Rename modal': 'Modal umbenennen',
  auto: 'auto',
  'Page from': 'Ab Seite',
  'Page to': 'Bis Seite',
  'PDF Settings': 'PDF-Einstellungen',
  'Select Pages': 'Seiten auswählen',
  'Video Settings': 'Video-Einstellungen',
  'Audio Settings': 'Audio-Einstellungen',
  'Vertically Scrollable': 'vertikal scrollbar',
  'Delay Time (seconds)': 'Verzögerung (Sekunden)',
  Active: 'Aktiv',
  'Click Behaviour': 'Klickverhalten',
  'Start/Stop': 'Start/Stop',
  Ignore: 'Ignorieren',
  Iframe: 'Iframe',
  Url: 'Url',
  Password: 'Passwort',
  'Activate Password': 'Passwortschutz aktivieren',
  'Set Password': 'Passwort setzen',
  Caption: 'Beschriftung',
  unsorted: 'Nicht zugeordnet',
  Columns: 'Spalten',
  '1 Column': '1 Spalte',
  '2 Columns': '2 Spalten',
  '3 Columns': '3 Spalten',
  '4 Columns': '4 Spalten',
  '5 Columns': '5 Spalten',
  '6 Columns': '6 Spalten',
  Rows: 'Zeilen',
  '1 Row': '1 Zeile',
  '2 Rows': '2 Zeilen',
  '3 Rows': '3 Zeilen',
  '4 Rows': '4 Zeilen',
  '5 Rows': '5 Zeilen',
  '6 Rows': '6 Zeilen',
  Layout: 'Layout',
  'Full width': 'Breite ausfüllen',
  'Full height': 'Höhe ausfüllen',
  'Horizontal center': 'Horizontal zentriert',
  'Horizontal left': 'Horizontal links',
  'Horizontal right': 'Horizontal rechts',
  'Indicator Color': 'Rahmenfarbe',
  'Active Color': 'Aktivfarbe',
  'Slide Settings': 'Seiteneinstellungen',
  'Width (Boxes)': 'Breite (Kästchen)',
  'Height (Boxes)': 'Höhe (Kästchen)',
  Justified: 'Galeriemodus',
  small: 'klein',
  medium: 'mittel',
  large: 'groß',
  'Loosen up gallery': 'Galerie auflockern',
  off: 'aus',
  'every 3 rows': 'alle 3 Zeilen',
  'every 6 rows': 'alle 6 Zeilen',
  'Fill box': 'Box ausfüllen',
  'Filename Ascending': 'Dateiname aufsteigend',
  'Filename Descending': 'Dateiname absteigend',
  'Order by': 'Sortieren nach',
  Thumbnail: 'Vorschaubild',
  'Custom font (regular)': 'Eigene Schriftart (Normal)',
  'Custom font (bold)': 'Eigene Schriftart (Fett)',
  Font: 'Schriftart',
  'Font (front)': 'Schriftart (Vorne)',
  'Font (back)': 'Schriftart (Hinten)',
  'Font (menu)': 'Menü-Schriftart'
}
